const ResultsCard = ({ res, i }) => {
	return (
		<a href={res.url} className="card-wrapper-link">
			<div
				key={i}
				date-i={i}
				data-date={res.post_data.post_date}
				className="card search-card card-helper card-helper--outline"
			>
				<div
					className={`ff-type-tag ff-type-tag--${res.tags[0].class}`}
					type=""
				>
					<span className="material-symbols-outlined">{res.tags[0].icon}</span>
					{res.tags[0].name}
				</div>
				<h3
					className="nested-link-span"
					dangerouslySetInnerHTML={{ __html: res.title }}
				></h3>
				<div
					dangerouslySetInnerHTML={{
						__html: res.excerpt,
					}}
				/>
				<div className="card-link nested-link-span action-color">
					{res.readMoreLabel}
				</div>
			</div>
		</a>
	);
};

export default ResultsCard;
